import { keyframes } from 'styled-components';

const t = {};

t.color = {
  black: 'rgb(34,34,34)',
  blackTrue: 'rgb(0,0,0)',
  blue: 'rgb(33,150,216)',
  blueLight: 'rgb(226,244,252)',
  grayDark: 'rgb(119,119,119)',
  graySemiDark: 'rgb(160,160,160)',
  gray: 'rgb(221,221,221)',
  grayLight: 'rgb(241,241,241)',
  green: 'rgb(102,187,106)',
  orange: 'rgb(244,132,46)',
  teal: 'rgb(52,184,180)',
  tealLight: 'rgb(223,243,243)',
  red: 'rgb(235, 55, 43)',
  yellow: 'rgb(255,204,0)',
  yellowLight: 'rgb(255,248,184)',
  white: 'rgb(251,251,251)',
  whiteTrue: 'rgb(255,255,255)',
};

t.rgba = function rgba(color, alpha = 1) {
  return alpha === 1 ? color : `rgba(${t.color[color].slice(4, -1)}, ${alpha})`;
};

t.spacing = multiplier => `${multiplier * 4}px`;

t.pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 ${t.rgba('black', 0.4)};
  }
  70% {
    box-shadow: 0 0 0 10px ${t.rgba('black', 0)};
  }
  100% {
    box-shadow: 0 0 0 0 ${t.rgba('black', 0)};
  }
`;

t.mq = {
  mobileSmall: 'max-width: 340px',
  mobile: 'max-width: 768px',
  desktop: 'min-width: 769px',
};

t.base = {
  fontColor: '#222',
  fontFamily: `'Visby', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif`,
  fontSize: '16px',
  lineHeight: 1.5,
  border: `2px solid ${t.color.grayLight}`,
  radius: '2px',
  spacing: {
    small: t.spacing(1),
    regular: t.spacing(2),
    large: t.spacing(4),
    huge: t.spacing(6),
    gigantic: t.spacing(8),
    humongous: t.spacing(10),
  },
  boxShadow: t.boxShadow2,
  pageWidth: '1500px',
};

t.fontNormal = 400;
t.fontSemibold = 600;
t.fontBold = 700;
t.boxShadow1 = `0 1px 3px ${t.rgba('black', 0.12)},
  0 1px 2px ${t.rgba('black', 0.24)}`;
t.boxShadow2 = `0 3px 6px ${t.rgba('black', 0.16)},
  0 3px 6px ${t.rgba('black', 0.23)}`;
t.boxShadow3 = `0 10px 20px ${t.rgba('black', 0.19)},
  0 6px 6px ${t.rgba('black', 0.23)}`;
t.boxShadow4 = `0 14px 28px ${t.rgba('black', 0.25)},
  0 10px 10px ${t.rgba('black', 0.22)}`;
t.boxShadow5 = `0 19px 38px ${t.rgba('black', 0.3)},
  0 15px 12px ${t.rgba('black', 0.22)}`;

export default t;



// WEBPACK FOOTER //
// ./src/config/theme.js